var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUpDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 16.5C33 14.9875 31.7625 13.75 30.25 13.75H16.005L17.82 5.005L17.875 4.3725C17.875 3.52 17.5175 2.75 16.9675 2.1725L14.795 0L1.21 13.585C0.4675 14.3275 0 15.3725 0 16.5V34.375C0 36.6575 1.8425 38.5 4.125 38.5H22.6875C24.3925 38.5 25.85 37.455 26.4825 35.9975L32.6975 21.45C32.89 20.9825 33 20.46 33 19.9375V16.5ZM61.875 27.5H43.3125C41.6075 27.5 40.15 28.545 39.5175 30.0025L33.3025 44.55C33.11 45.0175 33 45.54 33 46.0625V49.5C33 51.0125 34.2375 52.25 35.75 52.25H49.995L48.18 60.995L48.125 61.655C48.125 62.5075 48.4825 63.2775 49.0325 63.855L51.205 66L64.79 52.415C65.5325 51.6725 66 50.6275 66 49.5V31.625C66 29.3425 64.1575 27.5 61.875 27.5Z",
    fill: "#4D7766"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpDown);
export default __webpack_public_path__ + "static/media/thumbs_up_down.d72d5d4467bd70b3f632942befdbc9cd.svg";
export { ForwardRef as ReactComponent };